import { types } from 'mobx-state-tree'

const DictionaryUserModel = types.model('DictionaryUserModel', {
  id: types.optional(types.string, ''),
  userFullName: types.maybeNull(types.string),
})

export default DictionaryUserModel
